module.exports = __webpack_public_path__ + "static/media/youtube.affd459e.svg";